// @flow
import { tabViewActions } from './tabViewActionCreater';

const initialState = {
  selectedTab: 0
};

const tabViewReducer = (state: Object = initialState, action: Object) => {
  switch (action.type) {
    case tabViewActions.set_selected_tab:
      return Object.assign({}, state, { selectedTab: action.payload });
    default:
      return state;
  }
};

export default tabViewReducer;
